import { ApiStore } from './ApiStore';
import { CalcStore } from './CalcStore';
import { FaqStore } from './FaqStore';
import { FooterStore } from './FooterStore';
import { GalleryStore } from './GalleryStore';
import { HeaderStore } from './HeaderStore';
import { LoadingStore } from './LoadingStore';
import { NewsStore } from './NewsStore';
import { OrderStore } from './OrderStore';
import { PaymentStore } from './PaymentStore';
import { ScrollStore } from './ScrollStore';
import { ShowcaseStore } from './ShowcaseStore';
import { SuccessPopupStore } from './SuccessPopupStore';
import { UserStore } from './UserStore';
import { WidgetStore } from './WidgetStore';

import { FormsStore } from './forms/FormsStore';
import { AskFormStore } from './forms/AskFormStore';
import { DemoFormStore } from './forms/DemoFormStore';
import { CustomViewFormStore } from './forms/CustomViewFormStore';

export class Store {
  headerStore = new HeaderStore(this);

  userStore = new UserStore(this);

  paymentStore = new PaymentStore(this);

  galleryStore = new GalleryStore(this);

  scrollStore = new ScrollStore(this);

  apiStore = new ApiStore(this);

  loadingStore = new LoadingStore(this);

  widgetStore = new WidgetStore(this);

  footerStore = new FooterStore(this);

  faqStore = new FaqStore(this);

  newsStore = new NewsStore(this);

  showcaseStore = new ShowcaseStore(this);

  successPopupStore = new SuccessPopupStore(this);

  orderStore = new OrderStore(this);

  calcStore = new CalcStore(this);

  formsStore = new FormsStore(this);

  demoFormStore = new DemoFormStore(this);

  askFormStore = new AskFormStore(this);

  customViewFormStore = new CustomViewFormStore(this);

  stores = [];

  constructor() {
    Object.keys(this).forEach((key) => {
      if (key.endsWith('Store')) this.stores.push(this[key]);
    });
  }

  init() {
    this.stores.forEach((store) => {
      if (typeof store.init === 'function') store.init();
    });
  }
}

export const store = new Store();
